<template>
    <div class="print-page" v-if="data && user">
        <h2>{{ data.title }}</h2>
        <br/>
        <p class="al-center">（此表一式两份，一份由复筛机构留存，一份交家长）</p>
        <br/>
        <div class="d-flex justify-center">
            <h3>编号</h3>
            <input class="squ ml-ns" type="text" readonly :value="it" v-for="it in user.serialNumber"/>
        </div>
        <br/>
        <br/>
        <div class="d-flex justify-center" style="width: 70%; margin: auto; font-size: 18px; font-weight: bold;">
            <span>儿童姓名</span>
            <p class="d-flex-item" style="flex: 2;"><input class="line" type="text" readonly :value="user.name"/></p>
            <span>性别</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$common.sex.find(e => e.value === user.sex).text"/></p>
            <span>出生日期</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('YYYY')"/></p>
            <span>年</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('MM')"/></p>
            <span>月</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('DD')"/></p>
            <span>日</span>
        </div>
        <br/>
        <table border>
            <tr>
                <th width="170">初筛医疗机构名称</th>
                <td colspan="3"><input class="line" type="text"/></td>
            </tr>
            <tr>
                <th rowspan="2">初筛结果</th>
                <td width="160">预警征象筛查</td>
                <td width="160" colspan="2">
                    <span class="mask"/>
                    <ul>
                        <li><input type="checkbox" :checked="data.preliminaryScreeningResult.warningSigns === '未见异常' ? true : false"/> 未见异常</li>
                        <li><input type="checkbox" :checked="data.preliminaryScreeningResult.warningSigns !== '未见异常' ? true : false"/> 有，未通过项 <input class="line" type="text" :value="(data.preliminaryScreeningResult.warningSigns !== '未见异常' ? data.preliminaryScreeningResult.warningSigns : '')"/></li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask"/>
                    <ul class="d-flex">
                        <li class="mr-md"><input type="checkbox" :checked="data.preliminaryScreeningResult.langSocials[0].value === 1 ? true : false"/> 语言功能障碍或倒退</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.preliminaryScreeningResult.langSocials[1].value === 1 ? true : false"/> 社会交往功能障碍或倒退</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th rowspan="3">病史询问</th>
                <th colspan="3" class="al-left">是否有以下症状（可多选）</th>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask" v-if="data.edited === 1"/>
                    <ul class="d-flex">
                        <li class="mr-md"><input type="checkbox" :checked="data.medicalHistory.array[0] ? true : false" @click="set_medicalHistory(1, 0), data.medicalHistory.text = ''"/> 无</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.medicalHistory.array[1] ? true : false" @click="set_medicalHistory(1, 1)"/> 语言障碍</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.medicalHistory.array[2] ? true : false" @click="set_medicalHistory(1, 2)"/> 交流障碍</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.medicalHistory.array[3] ? true : false" @click="set_medicalHistory(1, 3)"/> 行为刻板</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.medicalHistory.array[4] ? true : false" @click="set_medicalHistory(1, 4)"/> 兴趣狭隘</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>其他具体症状或问题</td>
                <td colspan="2">
                    <span class="mask" v-if="data.edited === 1"/>
                    <input class="line" type="text" :readonly="!data.medicalHistory.array[0] ? false : true" v-model="data.medicalHistory.text"/>
                </td>
            </tr>
            <tr>
                <th rowspan="3">发育量表评估</th>
                <th colspan="3" class="al-left">儿心量表-II（0～6岁）</th>
            </tr>
            <tr>
                <td>发育商总分：{{ data.dsa.dqScore }}</td>
                <td colspan="3">
                    <p>
                        <span>大运动得分：{{ data.dsa.dqScore1 }}</span>
                        <span>精细动作得分：{{ data.dsa.dqScore2 }}</span>
                        <span>适应能力得分：{{ data.dsa.dqScore3 }}</span>
                    </p>
                    <p>
                        <span>语言得分：{{ data.dsa.dqScore4 }}</span>
                        <span>社会行为得分：{{ data.dsa.dqScore5 }}</span>
                    </p>
                </td>
            </tr>
            <tr>
                <td>测评结果</td>
                <td colspan="2">
                    <span class="mask"/>
                    <ul class="d-flex">
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 130 ? true : false"/> 优秀</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 110 && data.dsa.dqScore < 130 ? true : false"/> 良好</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 80 && data.dsa.dqScore < 110 ? true : false"/> 中等</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore >= 70 && data.dsa.dqScore < 80 ? true : false"/> 发育偏离</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.dsa.dqScore < 70 ? true : false"/> 发育障碍</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th rowspan="6">孤独症筛查量表评估</th>
                <th colspan="3" class="al-left">修订版孤独症筛查量表（M-CHAT）（18～24月龄）</th>
            </tr>
            <tr>
                <td colspan="3">
                    <span class="mask"/>
                    <div class="d-flex" v-if="data.mChat.result">项目阳性个数 <input class="d-flex-item line" type="text" :value="(data.mChat.itemPositive ? data.mChat.itemPositive : '')"/></div>
                    <p v-else>&nbsp;</p>
                </td>
            </tr>
            <tr>
                <td>
                    <p v-if="data.mChat.result">测评结果</p>
                    <p v-else>&nbsp;</p>
                </td>
                <td colspan="2">
                    <span class="mask"/>
                    <ul class="d-flex" v-if="data.mChat.result">
                        <li class="mr-md"><input type="checkbox" :checked="data.mChat.result && data.mChat.result !== '' && data.mChat.result === 0 ? true : false"/> 未见明显异常</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.mChat.result && data.mChat.result !== '' && data.mChat.result === 1 ? true : false"/> 未通过（存在孤独）</li>
                    </ul>
                    <p v-else>&nbsp;</p>
                </td>
            </tr>
            <tr>
                <th colspan="3" class="al-left">孤独症行为评定量表(ABC) （24月龄及以上）</th>
            </tr>
            <tr>
                <td>
                    <p v-if="data.abc.totalScore">总分：{{ data.abc.totalScore }}</p>
                    <p v-else>&nbsp;</p>
                </td>
                <td colspan="2">
                    <div class="d-block" v-if="data.abc.totalScore">
                        <p>
                            <span>感觉得分：{{ data.abc.score1 }}</span>
                            <span>社会交往得分：{{ data.abc.score2 }}</span>
                            <span>躯体运动得分：{{ data.abc.score3 }}</span>
                        </p>
                        <p>
                            <span>语言得分：{{ data.abc.score4 }}</span>
                            <span>生活自理得分：{{ data.abc.score5 }}</span>
                        </p>
                    </div>
                    <p v-else>&nbsp;</p>
                </td>
            </tr>
            <tr>
                <td>
                    <p v-if="data.abc.totalScore">测评结果</p>
                    <p v-else>&nbsp;</p>
                </td>
                <td colspan="2">
                    <span class="mask"/>
                    <ul class="d-flex" v-if="data.abc.totalScore">
                        <li class="mr-md"><input type="checkbox" :checked="data.abc.result === 0 ? true : false"/> 未见明显异常</li>
                        <li class="mr-md"><input type="checkbox" :checked="data.abc.result === 1 ? true : false"/> 未通过（存在可疑孤独症症状）</li>
                    </ul>
                    <p v-else>&nbsp;</p>
                </td>
            </tr>
            <tr>
                <th>复筛结果</th>
                <td colspan="3">
                    <span class="mask" v-if="data.edited === 1"/>
                    <ul>
                        <li><input type="checkbox" :checked="data.result === 0 ? true : false" @click="set_result(0)"/> 未见明显异常，3个月内复查</li>
                        <li><input type="checkbox" :checked="data.result === 1 ? true : false" @click="set_result(1)"/> 可疑（“儿心量表-II”评估分为70～79分），3个月内复查</li>
                        <li><input type="checkbox" :checked="data.result === 2 ? true : false" @click="set_result(2)"/> 异常（病史询问存在疑似孤独症症状或修订版孤独症筛查量表“M-CHAT”筛查未通过或孤独症行为评定量表“ABC”筛查未通过）</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>转诊建议</th>
                <td colspan="3">
                    <span class="mask" v-if="data.edited === 1"/>
                    <ul>
                        <li><input type="checkbox" :checked="data.referral === '0' ? true : false" @click="set_referral('0')"/> 不转诊</li>
                        <li><input type="checkbox" :checked="data.referral === '1' ? true : false" @click="set_referral('1')"/> 转诊，转至 <input class="line" type="text" :readonly="data.referral === '0' ? true : false" v-model="data.referralText" style="display: inline-block; width: 40%;"/> 进一步诊断，同时进行健康宣教</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>医生签字</th>
                <td>
                    <input class="line" type="text" readonly/>
                </td>
                <th width="140">填写日期</th>
                <td>
                    <div class="d-flex mt-xs">
                        <input class="d-flex-item line" type="text" readonly :value="$moment(data.saveTime).format('YYYY')"/>
                        <span>年</span>
                        <input class="d-flex-item line" type="text" readonly :value="$moment(data.saveTime).format('MM')"/>
                        <span>月</span>
                        <input class="d-flex-item line" type="text" readonly :value="$moment(data.saveTime).format('DD')"/>
                        <span>日</span>
                    </div>
                </td>
            </tr>
            <tr>
                <th>医疗机构</th>
                <td colspan="3">
                    <input class="line" type="text" readonly/>
                </td>
            </tr>
        </table>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            data: Object,
            user: Object,
        },
        data() {
            return {}
        },
        async beforeDestroy() {},
        async created() {
            console.log('复筛记录表------------->', this.data, this.user);
        },
        async mounted() {},
        methods: {
            async set_medicalHistory(d, i){
                console.log('this.set_medicalHistory------------->', d, i);
                if (i === 0 && d === 1){
                    this.data.medicalHistory.array = [1, 0, 0, 0, 0];
                } else {
                    this.data.medicalHistory.array[0] = 0;
                    this.data.medicalHistory.array[i] = d;
                }
                console.log('this.set_medicalHistory------------->', this.data.medicalHistory);
                await this.$forceUpdate();
            },
            async set_result(data){
                console.log('this.set_result------------->', data);
                this.data.result = data;
                await this.$store.commit("initPrintFormData", this.data);
                await this.$forceUpdate();
            },
            async set_referral(data){
                console.log('this.set_referral------------->', data);
                this.data.referral = data;
                await this.$store.commit("initPrintFormData", this.data);
                await this.$forceUpdate();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/fushai.vue